import React, { useRef } from "react";
import rx from "../../Assets/Images/rx.png";
import { Alert } from "react-bootstrap";
import BtnPrint from "../../Components/Commons/Buttons/BtnPrint";
import { formatDate, getDateToday } from "../../Helpers/Utils/Common";
// import { FORM } from "../../Constants/doctor";
import { Space, Row, Col, Modal } from "antd";
import FormHeader from "../Commons/FormHeader";
import FormFooter from "../Commons/Table/FormFooter";
import { FORM } from "../../Constants/doctor";

export default function ViewPrescription({
  show,
  onHide,
  data,
  therapeutics,
  assessmentId,
  patient,
  doctor,
  tab,
}) {
  const componentRef = useRef();
  if (therapeutics.length === 0) {
    return (
      <Modal
        // title="Print Prescription"
        open={show}
        onOk={onHide}
        okText="Okay"
        cancelText="Close"
        onCancel={onHide}
        className="ant-rx"
      >
        <Alert variant="warning" className="gotham">
          No therapeutics found for printing. Please add therapeutic details to
          the patient's assessment before attempting to print.
        </Alert>
      </Modal>
    );
  } else {
    return (
      <Modal
        // title="Print Prescription"
        open={show}
        // onOk={() => handlePrint(`prescription_${assessmentId}`)}
        // okText="Print"
        cancelText="Close"
        onCancel={onHide}
        className="center"
        footer={null}
      >
        <Row
          id={`prescription_${assessmentId}`}
          ref={componentRef}
          className="rx-container rx-container-prescription"
        >
          <Col span={24} className="px-4">
            <Row
              className="rx-header"
              // id='header'
            >
              <Col span={24}>
                <FormHeader />
                <Row>
                  <Col span={14} align="left">
                    <Space className="form-info">
                      <div>Patient Name:</div>
                      <strong>
                        {patient?.patient_name || patient?.full_name}
                      </strong>
                    </Space>
                  </Col>
                  <Col span={10} align="left">
                    <Space className="form-info">
                      <div>Age/Sex:</div>
                      <strong>
                        {patient?.age} / {patient?.patient_sex?.toUpperCase()}
                      </strong>
                    </Space>
                  </Col>
                </Row>
                <Row>
                  <Col span={14} align="left">
                    <Space className="form-info">
                      <div>Birthdate:</div>
                      <strong>{formatDate(patient?.birthdate)}</strong>
                    </Space>
                  </Col>
                  <Col span={10} align="left">
                    <Space className="form-info">
                      <div>Date:</div>
                      <strong>{patient.assessment_date}</strong>
                    </Space>
                  </Col>
                </Row>
                <Row>
                  <Col span={24} align="left">
                    <Space className="form-info">
                      <div>Address:</div>
                      <strong>
                        {patient?.patient_address || patient?.address}
                      </strong>
                    </Space>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="rx-content my-4">
              <Col span={2} id="rx">
                <img src={rx} height={70} width="auto" alt="rx" />
              </Col>
              <Col span={22}>
                <ul>
                  {therapeutics.length > 0 &&
                    therapeutics.map((med, index) => {
                      return (
                        <div
                          className={`row prescription-size content-left`}
                          key={index}
                        >
                          <div className="col">
                            <div className="row">
                              <div className="col">
                                <span> {index + 1 + ". "}</span>
                                <span>
                                  {med?.generic}/{med?.brand}
                                </span>
                                <span> {med?.dosage}</span>
                                <span> {med?.preparation}</span>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col ms-4">
                                <span> Sig: </span>
                                <span> {med?.instruction}</span>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-2">
                                {med.note && (
                                  <>
                                    <p>Note:</p>
                                  </>
                                )}
                              </div>
                              <div className="col">
                                {med.note && (
                                  <>
                                    <p style={{ whiteSpace: "pre-wrap" }}>
                                      {med.note}
                                    </p>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="col-3">
                            <span> {"#" + med?.quantity}</span>
                          </div>
                        </div>
                      );
                    })}
                </ul>
              </Col>
            </Row>
            {/* <FormFooter
              patient={patient}
              type="followup"
              tab={tab}
            /> */}
          </Col>
          <Col span={24}>
            <Row className="rx-footer" id="footer">
              <Col span={24}>
                <Row>
                  <Col className="ms-4" span={12} align="left">
                    {data?.outpatients && (
                      <>
                        <Space direction="horizontal">
                          <span>Follow Up Schedule:</span>
                          <strong>
                            {data?.outpatients[0]?.followup_on
                              ? formatDate(data?.outpatients[0]?.followup_on)
                              : ""}
                          </strong>
                        </Space>
                      </>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col className="ms-4 mb-4" span={12} align="left">
                    {data?.outpatients && (
                      <>
                        <Space direction="horizontal">
                          <span>Plan:</span>
                          <strong>
                            {data?.outpatients[0]?.plan
                              ? data?.outpatients[0]?.plan
                              : ""}
                          </strong>
                        </Space>
                      </>
                    )}
                  </Col>
                </Row>
              </Col>
              <Col span={24}>
                <Row>
                  <Col className="ms-4 mb-4" span={12} align="left">
                    <div className="signature-container">
                      {/* {doctor?.sign_url !== "" && (
                        <div className="signature-wrapper">
                          <div className="signature-image-wrapper">
                            <img
                              src={doctor?.sign_url}
                              alt="Doctor Signature"
                              className="signature-image"
                            />
                          </div>
                        </div>
                      )} */}
                      <div className="doctor-info">
                        <strong>{doctor?.doctor_name?.toUpperCase()}</strong>
                        <div>PRC No. {doctor?.prc_no}</div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col span={16}></Col>
          <Col span={8}>
            <BtnPrint
              label={"Print"}
              size={"xl"}
              divId={componentRef}
              // divId={`prescription_${assessmentId}`}
              fileName={`prescription_${patient?.full_name} (${patient.assessment_date}).pdf`}
            />
          </Col>
        </Row>
      </Modal>
    );
  }
}
